import { MeiliSearch } from "meilisearch";

const search = async (category?: string, filters?: string[]) => {
	if (
		!process.env.REACT_APP_MEILISEARCH_HOST ||
		!process.env.REACT_APP_MEILISEARCH_KEY ||
		!process.env.REACT_APP_MEILISEARCH_INDEX_NAME
	)
		return console.error("MeiliSearch credentials not found");
	const client = new MeiliSearch({
		host: process.env.REACT_APP_MEILISEARCH_HOST,
		apiKey: process.env.REACT_APP_MEILISEARCH_KEY,
	});

	const index = client.index(process.env.REACT_APP_MEILISEARCH_INDEX_NAME);
	let filterString = "";
	if (category) {
		filterString += `category='${category}'`;
	}
	filters?.forEach((filter) => {
		if (!!filterString) filterString += " AND";
		filterString += ` ${filter}`;
	});
	const response = await index.search("", {
		filter: filterString,
		sort: ['weight:asc'],
		limit: 1000,
	});
	return response;
};

export default search;
